import React from 'react'
import { Element } from 'react-scroll'
import WILSectionTitle from './WILSectionTitle';

const programFeatures = [
  {
    icon: "ai_file.svg",
    title: "Real-World Projects",
    description: "Gain hands-on experience by working on live, employer-led projects that tackle real business problems in Data Science, Machine Learning, and AI. These aren't case studies - they're actual challenges from companies."
  },
  {
    icon: "certificate.svg",
    title: "Structured Support & Guidance",
    description: "Receive end-to-end support through dedicated Program Coordinators, Technical Check-ins, and feedback loops to ensure you stay on track and get the most out of your WIL experience."
  },
  {
    icon: "certificate.svg",
    title: "Mentorship & Collaboration",
    description: "Collaborate with Technical Mentors, Industry Experts, and cross-functional teams. Learn how professionals work in fast-paced environments and get feedback that sharpens your skills and thinking."
  },
  {
    icon: "ai_file.svg",
    title: "Career-Ready Experience",
    description: "Complete Industry-vetted projects you can showcase in your portfolio. Demonstrate your applied skills to employers and stand out with practical experience that goes beyond certification."
  }
]

const WILAbout = () => {
  return (
    <>
      <Element
        name="WILAbout"
        className="datatalent-section-gap"
      >
        <div className="container eduvibe-animated-shape">
          <div className="row g-5 justify-content-center">
            <div className="col-12 mt-0 col-lg-7 px-0 px-md-4">
              <WILSectionTitle
                classes = "text-start"
                title = "What is Work Integrated Learning (WIL)"
              />
              <p className="mt-4">
                Work-Integrated Learning (WIL) is an educational approach that combines formal learning with practical, real-world work experiences. It allows students or professionals to apply their skills in actual work environments while continuing their education.
              </p>
              <p>
                It's a live work project that you can use to bolster your portfolio!
              </p>
            </div>
            <div className="col-12 mt-0 col-lg-5 px-0 px-md-4">
              <div className="wil-about-card">
                <h3 className="title color-white">WIL Projects</h3>
                <ul className="mb-0">
                  <li className="color-white">AI Prototype for public sector</li>
                  <li className="color-white">AI & ML for sports data</li>
                  <li className="color-white">Converting threads into vector database</li>
                  <li className="color-white">Supply Chain Optimization</li>
                  <li className="color-white">Health sciences data analytics</li>
                </ul>
              </div>
            </div>
            <div className="col-12 mt--80 px-0 px-md-4">
              <WILSectionTitle
                classes = "text-start"
                title = "Program Features"
              />
              <p className="wil-program-features mt-4">
                With our Data Science, ML & AI Program's experiential learning opportunities, you'll not only gain a solid theoretical foundation but also build the confidence and competence to thrive in real-world scenarios. Prepare yourself for a successful career by joining our program and unlocking the power of experiential learning.
              </p>
              <p className="wil-program-features">
                <em><strong>Note</strong>: The availability of internships and specific details may vary based on partnerships with companies and industry demand.</em>
              </p>
            </div>
            {programFeatures.map((programFeature, idx) => (
              <div className="col-12 col-lg-6 px-0 px-md-4" key={idx}>
                <div className="wil-program-features-card">
                  <img src={`${process.env.PUBLIC_URL}/images/industry-wil/${programFeature.icon}`} alt="illustration" />
                  <h5 className="mt-2 mb-2">{programFeature.title}</h5>
                  <p className="mb-0">{programFeature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Element>
    </>
  )
}

export default WILAbout;